export default __webpack_public_path__ + "static/media/desislava.3f8a46ac.jpg";